import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/subAccount",
  name: "subAccount",
  component: function component() {
    return import("../../../views/dev-plug/subAccount/index");
  },
  meta: {
    title: "切换账号",
    foot: true
  }
}, {
  path: "/subAccount/creat/:status",
  name: "subAccountCreat",
  component: function component() {
    return import("../../../views/dev-plug/subAccount/creat");
  },
  meta: {
    title: "编辑账号",
    foot: true,
    notKeepAlive: true
  }
}];